import { controls, currencyToNumber, grouped } from "../../controls";

const attendance_status = {
  label: "Attendance Status",
  starting: true,
  url: "attendance_status",
  pageLabel: "Attendance Status",
  pageType: "history",
  visitingBranches: true,
  filter: [
    ...controls.magicDateLabel({ label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", default: "n", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Attendance Status" }),
    ...controls.text({ tab: "general", placeHolder: "A/P", width: "col-sm-2", name: "attendance_status", maxlength: 1 }),
    ...controls.displayText({ tab: "general", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Designation", width: "col-sm-2", star: false }),
    ...controls.oc({ tab: "general", c: "Designation", width: "col-sm-2", placeHolder: "Designation Code", name: "designation_code", fastpath: "designations" }),
    ...controls.showData({ tab: "general", displaytype: "capital", width: "col-sm-2", data: "designation_display" }),
    ...controls.displayText({ tab: "general", label: "Department", width: "col-sm-2", star: false }),
    ...controls.oc({ tab: "general", c: "Department", placeHolder: "Department Code", width: "col-sm-2", name: "department_code", fastpath: "departments" }),
    ...controls.showData({ tab: "general", displaytype: "capital", width: "col-sm-2", data: "department_display" }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", label: "From Time", str: true }),
    ...controls.text({ tab: "general", placeHolder: "HH:MM EX.10:30", isRequired: true, width: "col-sm-2", name: "from_tme", maxlength: 5 }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", label: "To Time", }),
    ...controls.text({ tab: "general", placeHolder: "HH:MM EX 12:00", isRequired: true, width: "col-sm-2", name: "to_time", maxlength: 5 }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", }),
    ...controls.displayText({ tab: "general", label: "In Branch", }),
    ...controls.oc({
      tab: "general", length: 4, c: "Branch", placeHolder: "In Branch Code",
      name: "in_branch_code", isRequired: true, fastpath: "branches", displayData: { branch_code: "in_branch_code", branch_display: "in_branch_display" }
    }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "in_branch_display" }),

    ...controls.displayText({ tab: "general", label: "Out Branch", }),
    ...controls.oc({
      tab: "general", length: 4, c: "Branch", placeHolder: "Out Branch Code",
      name: "out_branch_code", isRequired: true, fastpath: "branches", displayData: { branch_code: "out_branch_code", branch_display: "out_branch_display" }
    }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "out_branch_display" }),

    ...controls.displayText({ tab: "general", label: "Employee", width: "col-sm-2", star: false }),
    ...controls.oc({ tab: "general", c: "Employee", placeHolder: "Employee Code", width: "col-sm-2", name: "employee_code", fastpath: "employees" }),
    ...controls.showData({ tab: "general", displaytype: "capital", width: "col-sm-2", data: "employee_display" }),


  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Attendance Status",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Employee Code",
        accessor: "employee_code",
        rwidth: "*"
      },
      {
        Header: "Employee Name",
        accessor: "employee_display"
      },
      {
        Header: "Designation",
        accessor: "designation_display"
      },
      {
        Header: "Departments",
        accessor: "department_display"
      },

      {
        Header: "In Time",
        accessor: "in_time"
      },
      {
        Header: "Out Time",
        accessor: "out_time"
      },
      {
        Header: "Attendance Status",
        accessor: "att_status"
      },
      {
        Header: "In Branch",
        accessor: "in_branch"
      },
      {
        Header: "Out Branch",
        accessor: "out_branch"
      }

    ]
  }
};

export default attendance_status;